import { ReportsController } from './reports-controller';
import { flow, toPairs, sortBy, fromPairs, keys, map, values } from 'lodash';

export default class extends ReportsController {

  chartMap() {
    return Object.freeze({
      chart: 'bar'
    })
  }

  datasets() {
    return [{
      data: this.chartModel.data,
      fill: true,
      borderWidth: 2,
      hoverOffset: 4
    }]
  }

  formatReportData() {
    let data = {};

    this.reportValue.data.forEach(row => {
      if (row._type === 'data') { // eslint-disable-line no-underscore-dangle
        if (this.chartModel.destinationId) {
          if (row.destination_id === this.chartModel.destinationId) {
            this.addRow(data, row);
          }
        } else {
          this.addRow(data, row);
        }
      }
    }, this);

    // Sort values by total (big to small)
    // Is this even necessary? Might opt for better JS solution
    data = flow(toPairs, sortBy(1), fromPairs)(data);

    let labels = map(keys(data), function(l) {
      return l === 'null' ? '(online)' : l;
    });

    let data_value = values(data).map(function(n) {
      return parseFloat(n.toFixed(2));
    });

    return {
      labels: labels,
      data: data_value
    };
  }

  addRow(data, row) {
    data[row.primary_text] = data[row.primary_text] || 0;
    data[row.primary_text] += this.moneyToFloat(row.total_collected || 0);
  }

  getDefaultOptions(_, chartColor) {
    return {
      tooltips: {
        mode: 'nearest',
        position: 'average'
      },
      plugins: {
        legend: {
          display: false
        },
        autocolors: {
          customize(context) {
            const lighten = (color, value) => chartColor(color).lighten(value).rgbString();
            const colors = context.colors;
            return {
              background: lighten(colors.background, 0.3),
              border: lighten(colors.border, 0.3)
            };
          },
          offset: 2
        }
      },
      indexAxis: 'y',
      scales: {
        x2: {},
        x: {
          display: false
        },
        xAxis: {
          display: false
        }
      }
    }
  }
}
